const TripBoardGraphqlTypeKeyMap = {
    TripBoard: 'uuid',
    Listing: 'listingId'
};

const dataIdFromObjectForTripBoard = (object) =>
    !!TripBoardGraphqlTypeKeyMap[object.__typename] && object[TripBoardGraphqlTypeKeyMap[object.__typename]];

export default dataIdFromObjectForTripBoard;
